<template>
    <div>
        <SelectButton
            :class="{ 'p-invalid': props.isInvalid }"
            v-model="selectedOption"
            :options="[
                { label: 'True', value: 1 },
                { label: 'False', value: 0 },
            ]"
            optionLabel="label"
            optionValue="value"
            @change="emit('update:modelValue', selectedOption)"
        />
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';

const emit = defineEmits(['update:modelValue']);
// props
const props = defineProps({
    modelValue: {
        type: Number,
    },
    isInvalid: {
        type: Boolean,
    },
});

const selectedOption = ref(null);

onMounted(() => {
    selectedOption.value = props.modelValue;
});
</script>
